module.exports = __webpack_public_path__ + "static/media/landing-page-image.c84ba1ed.png";